import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuBox from "../../components/Custom/CustomizedMenuBox";
import { useAuth, usePermission } from "../../hooks/use-auth";

const Sales = () => {
  const { permissions } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [allPermissionList, setAllPermissionList] = useState([]);

  const isAdmin = "ADMIN__ADMIN__ADMIN";

  const breadcrumbs = [
    {
      name: t("sales.index"),
    },
  ];

  const {
    quotationPermission,
    salesOrderPermission,
    salesReturnPermission,
    salesReportPermission,
  } = usePermission();

  const menuList = [
    allPermissionList.some((permission) =>
      [quotationPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("sales.quotation.index"), navigateTo: "quotation" },
    allPermissionList.some((permission) =>
      [salesOrderPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("sales.order.index"), navigateTo: "order" },
    allPermissionList.some((permission) =>
      [salesReturnPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("sales.return.index"), navigateTo: "return" },
    allPermissionList.some((permission) =>
      [salesReportPermission.VIEW, isAdmin].includes(permission)
    ) && { title: t("sales.report.index"), navigateTo: "report" },
  ];

  const formatMenuList = menuList.filter((menu) => menu !== false);

  useEffect(() => {
    setAllPermissionList(permissions);
  }, [permissions]);

  const renderMenuList = () =>
    formatMenuList.map((menu) => (
      <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={menu.title}>
        <CustomizedMenuBox
          title={menu.title}
          linkTo={`${pathname}/${menu.navigateTo}`}
          isGridItem
        />
      </Grid>
    ));

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ my: 2 }}>
        <Grid container spacing={1}>
          {renderMenuList()}
        </Grid>
      </Box>
    </>
  );
};

export default Sales;
